// @ts-nocheck

import React from 'react';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import externalLinkActionCreators from '../../actions/externallink';
import { actions as loginActionCreators } from '../../actions/login';
import userActionCreators from '../../actions/user';
import useBindActionsCreator from '../../hooks/useBindActionsCreator';
import useMergeProps from '../../hooks/useMergeProps';

import UserNotification from './UserNotification';
import selectUserNotificationProps from './UserNotification.selector';

const UserNotificationContainer = () => {
  const selectedProps = useSelector(selectUserNotificationProps);

  const actions = useMemo(
    () => ({
      ...userActionCreators,
      ...loginActionCreators,
      ...externalLinkActionCreators,
      doLogout: () => loginActionCreators.doLogout(selectedProps.jwt),
    }),
    [selectedProps.jwt],
  );
  const actionsProps = useBindActionsCreator(actions);

  const enhancedProps = useMergeProps({ selectedProps, actionsProps });

  return <UserNotification {...enhancedProps} />;
};

export default UserNotificationContainer;
